import angular from 'angular';

import CalendarSelectDefaultModalComponent from './calendar-select-default-modal.cmpt';

export default angular
    .module('application.component.modals.component.calendar-select-default-modal', [])
    .component(CalendarSelectDefaultModalComponent.selector, CalendarSelectDefaultModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/calendar-select-default-modal/index.js